const $ = jQuery.noConflict()

var self = module.exports = {
  init: function(trigger) {
    self.events.click(trigger)
    self.data = [];

    $("select[name='enquiry-type'] option").each(function(index, elem) {
      self.data.push( { type: $(elem).data('etype'), value: $(elem).val(), name: $(elem).text() });
    }) 

    self.service.manageOptions($('select[name="branch-enquiry-type"]'));
  },

  events: {
    click: function(trigger) {
      $(document).on('change', '#contact-branch-enquiry-type', function(event) {
        event.preventDefault()
        self.service.manageOptions(event.target)
      })
    }
  },

  service: {
    manageOptions: function(target) {
      var selectedValue = $(target).find(":selected").val(),
          optionHtml = "",
          selectedDataType = $(target).find(":selected").data('type') 


      $("select[name='enquiry-type']").prop('selectedIndex', 0).change();

      if(selectedDataType == 'global' ){
        optionHtml = '';
        $(target).parent().next().hide();
      }else{
        $(target).parent().next().show();
      }
   

      self.data.map( function(elem) {
        if(selectedValue == elem.type) {
          optionHtml += '<option value="'+ elem.value +'">'+ elem.name +'</option>';
        }
      });
       
      $('#contact-enquiry-type').html(optionHtml);  
       
    },
  }
}
